if (!customElements.get('adeia-card-gallery')) {
  customElements.define(
    'adeia-card-gallery',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const track = this.querySelector('.adeia-card-gallery__track');
        const slides = [...track.children];
        const dots = [...this.querySelectorAll('.adeia-card-gallery__dot')];
        let startX = 0;
        let startY = 0;
        let dragged = false;
        let frame;

        track.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          startY = event.clientY;
          dragged = false;
        });

        track.addEventListener('pointermove', (event) => {
          if (
            Math.abs(event.clientX - startX) > 8 ||
            Math.abs(event.clientY - startY) > 8
          ) {
            dragged = true;
          }
        });

        track.addEventListener('pointercancel', () => {
          dragged = true;
        });

        track.addEventListener('click', (event) => {
          if (dragged) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);

        const updateDots = () => {
          const trackLeft = track.getBoundingClientRect().left;
          let closest = 0;
          let smallestDistance = Infinity;

          slides.forEach((slide, index) => {
            const distance = Math.abs(
              slide.getBoundingClientRect().left - trackLeft
            );
            if (distance < smallestDistance) {
              smallestDistance = distance;
              closest = index;
            }
          });

          dots.forEach((dot, index) => {
            dot.setAttribute('aria-current', String(index === closest));
          });
        };

        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(updateDots);
        }, { passive: true });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const offset =
              slides[index].getBoundingClientRect().left -
              track.getBoundingClientRect().left;

            track.scrollBy({
              left: offset,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth'
            });
          });
        });
      }
    }
  );
}
